<template>
  <modal
    size="xl"
    id="modalTurma"
    :exibir="exibir"
    :titulo="item.nomeRelatorio"
    :campos="$refs"
    @fechar="fecharModal"
  >
    <input-select-search
      ref="disciplina"
      :label="$t('ACADEMICO.DISCIPLINA')"
      :placeholder="$t('GERAL.TODOS')"
      :options="disciplinas"
      v-model="disciplinaId"
    />

    <template #modal-footer>
      <div class="d-flex justify-content-between w-100">
        <b-button variant="secondary" @click="fecharModal">
          {{ $t('GERAL.FECHAR') }}
        </b-button>
        <b-button
          variant="primary"
          @click="gerarRelatorio"
          v-if="podeVisualizar"
        >
          {{ $t('GERAL.GERAR_RELATORIO') }}
        </b-button>
      </div>
    </template>
  </modal>
</template>
<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import pdf from '@/common/utils/pdf';
import Permissoes from '@/components/mixins/permissoes';

// Services:
import DisciplinasService from '@/common/services/academico/disciplinas.service.js';
import PainelProfessorService from '@/common/services/painel-professor/painel-professor';

// Components:
import Modal from '@/components/modal/Modal';
import { InputSelectSearch } from '@/components/inputs';

export default {
  mixins: [Permissoes],
  props: {
    item: { type: Object, default: Object },
  },
  components: {
    Modal,
    InputSelectSearch,
  },
  data() {
    return {
      exibir: false,
      disciplinas: [],
      disciplinaId: null,
    };
  },
  methods: {
    valid() { return true },
    
    getDisciplinasPorTurma(turmaId) {
      if (!turmaId) return;
      this.$store.dispatch(START_LOADING);
      DisciplinasService.buscarPorTurmaId(turmaId)
        .then(({ data }) => {
          const itens = data.map((item) => ({
            text: item.descricao,
            value: item.id,
          }));
          this.disciplinas = itens;
          this.disciplinas.unshift({
            text: 'Todos',
            value: null,
          });

          this.exibir = true;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    async gerarRelatorio() {
      this.$store.dispatch(START_LOADING);
      await PainelProfessorService.imprimirRelatoriosDeFechamento(
          {
            ...this.item.dadosFiltro,
            disciplinaId: this.disciplinaId
          },
          this.item.rota
        ).then(({ data }) => {
          if (data.documento) {
            const bytes = pdf.base64ToArrayBuffer(data.documento);
            const blob = new Blob([bytes], { type: 'application/pdf' });

            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = data.nomeArquivo;
            link.click();
          }
        }).catch((err) => {
          mensagem.showErrors(err);
        }).finally(() => {
          this.$store.dispatch(STOP_LOADING);
        })
    },
    fecharModal() {
      this.exibir = false;
      this.disciplinas = [],
      this.disciplinaId = null,
      this.$emit('fechar');
    },
  },
};
</script>
